﻿import React from 'react';
import { UserAccess, UserHasAccess } from 'components/user-access';
import { Breadcrumbs } from 'components/navigation';
import { PageRestricted } from 'pages/errors/page-restricted';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { DocumentUploader } from 'pages/policy/shared';

export function UploadDocumentPage(props) {
    var navigate = useNavigate();
    const internalPermission = UserHasAccess("Internal");
    const requiredAction = "Documents:Manage";

    function onFinish() {
        navigate("/policy-management/policies");
    }

    return (
        <>

            <UserAccess perform={requiredAction}
                yes={() => (
                    <div className="row">

                        <Breadcrumbs items={props.breadcrumbs} />

                        <h2 className={classNames({ 'spacer-bottom': !internalPermission })}>Upload Documents</h2>

                        <DocumentUploader onFinish={onFinish} />
                    </div>
                )}
                no={() => (
                    <PageRestricted />
                )}
            />
        </>
    );
}